(function($) {

    $(document).ready(function () {

        if ($('.key-figures-swiper').length) {
            var keyFigures = new Swiper ('.key-figures-swiper', {
                slidesPerView: 1,
                allowTouchMove: false,
                speed: 600,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
            });

            keyFigures.slideTo($('.key-figures-swiper').data('slide-to-activate'));

            $('.key-figures-nav li').on('click', function() {
                var $this = $(this);

                $this.siblings().removeClass('active');
                $this.addClass('active');

                keyFigures.slideTo($this.data('slide-index'));
            });
        }

    });

})( jQuery );